const config = {
   	apiUrl : process.env.REACT_APP_API_URL,
   	pdfUrl : process.env.REACT_APP_PDF_URL,
   	siteUrl : process.env.REACT_APP_SITE_URL,
	  phpCompanyBaseUrl : `${process.env.REACT_APP_SITE_URL}company/`,
	  rootSiteUrl : process.env.REACT_APP_ROOT_SITE_URL,
	  jobIdKey: process.env.REACT_APP_JOB_KEY,
	  deptIdKey: process.env.REACT_APP_DEPT_KEY,
    siteDomain: (process.env.SITE_DOMAIN !== undefined) ? process.env.SITE_DOMAIN : '.protrackersystem.com'
}
export default config;

